import React from 'react';
import { observer } from 'mobx-react';
import { Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import RouterWrapperComponent from './RouterWrapperComponent';
import ModalComponent from './components/shared_components/ModalComponent';
import RouterWithProvider from './RouterWithProvider';
import CalculationFormContainer from './containers/tool/step2/CalculationFormContainer';
import OverviewContainer from './containers/tool/step3/OverviewContainer';
/* stores */
import CalculationFormData from './stores/tool/CalculationFormStore';
import ToolOverviewData from './stores/tool/OverviewStore';
import SavingsContainer from './containers/tool/step4/SavingsContainer';
import SavingsData from './stores/tool/SavingsStore';
import ToolSettingData from './stores/ToolSettingStore';
import ActiveStepsData from './stores/tool/ActiveStepsStore';
import ValidationData from './stores/tool/validation/ValidationStore';

@observer
class Tool extends React.Component {
  history = createBrowserHistory({ basename: '/' });

  componentDidMount() {
    ToolSettingData.getAdvisorSearchUrl();
  }

  render() {
    const stores = {
      CalculationFormData,
      ToolOverviewData,
      SavingsData,
      ActiveStepsData,
      ToolSettingData,
      ValidationData,
    };
    return (
      <RouterWithProvider stores={stores}>
        <div className="tool-router">
          <ModalComponent />
          <Route
            exact
            path={'/'}
            component={() => (
              <RouterWrapperComponent>
                <CalculationFormContainer />
              </RouterWrapperComponent>
            )}
          />
          <Route
            exact
            path={'/step-1'}
            component={() => (
              <RouterWrapperComponent>
                <CalculationFormContainer />
              </RouterWrapperComponent>
            )}
          />
          <Route
            exact
            path={'/step-2'}
            component={() => (
              <RouterWrapperComponent>
                <OverviewContainer />
              </RouterWrapperComponent>
            )}
          />
          <Route
            exact
            path={'/step-3'}
            component={() => (
              <RouterWrapperComponent>
                <SavingsContainer />
              </RouterWrapperComponent>
            )}
          />
        </div>
      </RouterWithProvider>
    );
  }
}

export default Tool;
